/** English — the canonical dictionary. Its keys define {@link TranslationKey}. */
export const en = {
  'app.name': 'Volt',

  'section.chat': 'Chat',
  'section.image': 'Images',
  'section.video': 'Video',
  'section.video2': 'Video 2 (Marketing Studio)',
  'section.character': 'Character',
  'section.audio': 'Music & Audio',
  'section.voice': 'Voice',
  'section.design': 'Design',

  'common.loading': 'Loading…',
  'common.error': 'Something went wrong',
  'common.retry': 'Try again',
  'common.refresh': 'Refresh',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.save': 'Save',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.create': 'Create',
  'common.apply': 'Apply',
  'common.offline': 'Offline — showing cached data',
  'common.you': 'You',
  'common.assistant': 'Assistant',
  'common.empty': 'Nothing here yet',
  'common.back': 'Back',

  'auth.loading': 'Signing you in…',
  'auth.openInTelegram': 'Open me inside Telegram',
  'auth.openInTelegramHint':
    'Volt runs as a Telegram Mini App. Launch it from your Telegram chat with the bot to sign in.',
  'auth.retry': 'Retry',
  'auth.error': 'Could not sign you in',
  'auth.devHint': 'Developer preview — running without Telegram data.',

  'topbar.menu': 'Open menu',
  'topbar.settings': 'Settings',
  'topbar.balance': 'Balance',

  'directChat.open': 'Open personal chat',
  'pager.chat': 'Chat',
  'pager.label': 'Page switcher',
  'directChat.title': 'Personal chat',
  'directChat.yourId': 'Your ID: {id}',
  'directChat.addPlaceholder': 'Public ID or Telegram @username',
  'directChat.addFriend': 'Add friend',
  'directChat.addSelf': 'You cannot add yourself as a friend.',
  'directChat.friends': 'Friends',
  'directChat.noFriends': 'No friends yet. Add someone by public ID or Telegram @username.',
  'directChat.selectFriend': 'Choose a friend to open the conversation.',
  'directChat.noMessages': 'No messages yet. Say hello!',
  'directChat.messagePlaceholder': 'Write a message…',
  'directChat.send': 'Send message',
  'directChat.notFound': 'No user was found with that ID or Telegram username.',
  'directChat.noPermission': 'You can message only a friend.',
  'directChat.addError': 'Check the ID or username; you may already have added this person.',
  'directChat.error': 'Could not load the chat. Please try again.',
  'directChat.openDrawer': 'Open conversations',
  'directChat.chats': 'Conversations',
  'directChat.groups': 'Groups',
  'directChat.newGroup': 'New group',
  'directChat.createGroup': 'Create group',
  'directChat.groupName': 'Group name',
  'directChat.selectMembers': 'Select members ({count}/50 including you)',
  'directChat.memberCount': '{count} members',
  'directChat.messages': 'Messages',
  'directChat.messageActions': 'Message actions',
  'directChat.edit': 'Edit message',
  'directChat.editing': 'Editing message',
  'directChat.saveEdit': 'Save changes',
  'directChat.share': 'Share messages',
  'directChat.selectMessage': 'Select message',
  'directChat.selectedCount': 'Selected: {count}',
  'directChat.aiConfigurationError':
    'No supported AI model is available. Choose another model or ask the administrator to configure a provider.',
  'directChat.reply': 'Reply',
  'directChat.replyingTo': 'Replying to {name}',
  'directChat.forward': 'Forward',
  'directChat.forwarded': 'Forwarded',
  'directChat.chooseDestination': 'Choose a conversation to forward to',
  'directChat.deleteForMe': 'Delete for me',
  'directChat.deleteForEveryone': 'Delete for everyone',
  'directChat.deleteForEveryoneConfirm': 'Delete this message for everyone in the chat?',
  'directChat.aiAttribution': 'Artificial Intelligence',
  'directChat.aiToggleEnabled': 'AI replies enabled',
  'directChat.aiToggleDisabled': 'AI replies disabled',
  'directChat.aiGenerating': 'AI is replying…',
  'directChat.aiGenerationError': 'Failed to generate AI reply: {error}',
  'directChat.aiChooseModel': 'Choose AI model',
  'directChat.aiLongPressHint': 'Hold to choose model',
  'directChat.sent': 'Sent',
  'directChat.delivered': 'Delivered',
  'directChat.read': 'Read',
  'directChat.loadOlder': 'Load earlier messages',
  'directChat.mute': 'Mute',
  'directChat.unmute': 'Unmute',
  'directChat.muted': 'Muted',
  'directChat.draft': 'Draft:',
  'directChat.unreadDivider': 'Unread messages',
  'directChat.typing': 'typing…',
  'directChat.online': 'online',
  'directChat.voiceRecord': 'Record voice message',
  'directChat.voiceStop': 'Stop recording',
  'directChat.voiceUnavailable': 'Microphone is unavailable',
  'directChat.pinnedMessage': 'Pinned message',
  'directChat.pinMessage': 'Pin message',
  'directChat.unpinMessage': 'Unpin message',
  'directChat.delete': 'Delete',
  'directChat.pushEnable': 'Enable notifications',
  'directChat.pushDisable': 'Disable notifications',
  'directChat.pushDenied': 'Notifications are blocked in the browser',
  'directChat.removeAttachment': 'Remove attachment',
  'directChat.searchPlaceholder': 'Search messages',
  'directChat.searchResults': 'Search results',
  'directChat.noResults': 'Nothing found',
  'directChat.addMenu': 'New chat or group',
  'directChat.newChat': 'New chat',
  'directChat.backToChats': 'Back to chats',
  'directChat.noChats': 'No chats yet. Tap + to start one.',
  'directChat.noArchived': 'No archived chats',
  'directChat.chatActions': 'Chat actions',
  'directChat.pin': 'Pin',
  'directChat.unpin': 'Unpin',
  'directChat.archive': 'Archive',
  'directChat.unarchive': 'Unarchive',
  'directChat.rename': 'Rename',
  'directChat.renameTitle': 'Rename contact',
  'directChat.renamePlaceholder': 'Name (empty to reset)',
  'directChat.block': 'Block',
  'directChat.unblock': 'Unblock',
  'directChat.deleteChat': 'Delete chat',
  'directChat.deleteForBoth': 'Delete for both',
  'directChat.leaveGroup': 'Leave group',
  'directChat.archivedChats': 'Archived ({count})',
  'directChat.blockedBanner': 'You blocked this user.',
  'directChat.blockedBadge': 'Blocked',
  'directChat.unread': '{count} unread',

  'sidebar.title': 'Chats',
  'sidebar.newChat': 'New chat',
  'sidebar.search': 'Search',
  'sidebar.searchPlaceholder': 'Search chats…',
  'sidebar.projects': 'Projects',
  'sidebar.newProject': 'New project',
  'sidebar.noConversations': 'No conversations yet',
  'sidebar.archived': 'Archived',
  'sidebar.showArchived': 'Show archived',
  'sidebar.hideArchived': 'Hide archived',
  'sidebar.pinned': 'Pinned',
  'sidebar.dropToPin': 'Drop here to pin',
  'sidebar.dropToUnpin': 'Drop here to unpin',
  'sidebar.today': 'Today',
  'sidebar.yesterday': 'Yesterday',
  'sidebar.previous7Days': 'Previous 7 days',
  'sidebar.previous30Days': 'Previous 30 days',
  'sidebar.older': 'Older',
  'sidebar.newFolder': 'New folder',
  'sidebar.folderName': 'Folder name…',
  'sidebar.removeFromFolder': 'Remove from folder',
  'sidebar.folders': 'Folders',
  'sidebar.history': 'Chat history',
  'sidebar.allChats': 'All chats',

  'menu.rename': 'Rename',
  'menu.pin': 'Pin',
  'menu.unpin': 'Unpin',
  'menu.archive': 'Archive',
  'menu.unarchive': 'Unarchive',
  'menu.addToFolder': 'Add to folder',
  'menu.moveUp': 'Move up',
  'menu.moveDown': 'Move down',
  'menu.delete': 'Delete',
  'menu.deleteTitle': 'Delete chat?',
  'menu.deleteConfirm': 'This conversation and its messages will be permanently deleted.',

  'project.name': 'Project name',
  'project.description': 'Description',
  'project.systemPrompt': 'Custom instructions',
  'project.systemPromptHint':
    'These instructions are sent to the model for every chat in the project.',
  'project.create': 'Create project',
  'project.empty': 'No projects yet',

  'composer.placeholder': 'Message Volt…',
  'composer.imagePlaceholder': 'Describe the image you want…',
  'composer.videoPlaceholder': 'Describe the video you want…',
  'composer.characterPlaceholder': 'Describe your character…',
  'composer.audioPlaceholder': 'Describe the music or audio…',
  'composer.voicePlaceholder': 'Text to turn into speech…',
  'composer.send': 'Send',
  'composer.stop': 'Stop generating',
  'composer.attach': 'Attach files',
  'composer.attachTitle': 'Add attachment',
  'composer.attachAllPhotos': 'All photos',
  'composer.attachCamera': 'Camera',
  'composer.attachPhotos': 'Photos',
  'library.fromLibrary': 'From my generations',
  'library.title': 'My generations',
  'library.empty': 'You have not generated anything yet',
  'library.loading': 'Loading…',
  'library.loadMore': 'Show more',
  'library.attach': 'Attach ({count}/{max})',
  'library.loadFailed': 'Could not load the file. Please try again.',
  'composer.attachFiles': 'Files',
  'composer.attachFilesHint': 'Photos without compression',
  'composer.attachToFolder': 'Add to folder',
  'composer.voiceMode': 'Voice mode',
  'quiz.submit': 'Continue',
  'quiz.sent': 'Answers sent',
  'quiz.preparing': 'Preparing questions…',
  'quiz.multipleHint': 'choose any',
  'quiz.answersIntro': 'My answers:',
  'voice.title': 'Voice conversation',
  'voice.status.starting': 'Connecting microphone…',
  'voice.status.listening': 'Listening…',
  'voice.status.transcribing': 'Recognizing…',
  'voice.status.thinking': 'Thinking…',
  'voice.status.speaking': 'Speaking…',
  'voice.status.error': 'Voice conversation stopped',
  'voice.hint': 'Just speak. I will answer when you pause.',
  'voice.tapToInterrupt': 'Tap the circle to interrupt',
  'voice.interrupt': 'Interrupt and speak',
  'voice.end': 'End conversation',
  'voice.micDenied': 'Allow microphone access to talk.',
  'voice.micUnavailable': 'The microphone is not available here.',
  'voice.ttsFallback': 'Using your device voice for replies.',
  'voice.settings': 'Voice settings',
  'voice.holdToTalk': 'Hold to talk',
  'voice.releaseToSend': 'Release to send',
  'voice.set.voice': 'Voice',
  'voice.set.speed': 'Speech speed',
  'voice.set.tone': 'Tone',
  'voice.tone.neutral': 'Neutral',
  'voice.tone.warm': 'Warm',
  'voice.tone.cheerful': 'Cheerful',
  'voice.tone.calm': 'Calm',
  'voice.set.model': 'Model for the call',
  'voice.model.fast': 'Fast',
  'voice.model.chat': 'Same as chat',
  'voice.set.recognition': 'Speech recognition',
  'voice.recognition.standard': 'Standard',
  'voice.recognition.high': 'Improved',
  'voice.set.talkMode': 'Talking',
  'voice.talk.auto': 'Hands-free',
  'voice.talk.push': 'Push to talk',
  'voice.set.reaction': 'Reaction to pauses',
  'voice.reaction.quick': 'Quick',
  'voice.reaction.normal': 'Normal',
  'voice.reaction.calm': 'Patient',
  'voice.set.bargeIn': 'Interrupt by voice',
  'voice.set.bargeInHint': 'Talk over the assistant to stop it. Works best with headphones.',
  'voice.set.cues': 'Sound while thinking',
  'voice.set.webSearch': 'Web access',
  'composer.voiceInput': 'Voice input',
  'composer.dialogUnsupported': 'Voice input is not supported in this browser',
  'composer.listening': 'Listening…',
  'composer.thinking': 'Thinking…',
  'composer.model': 'Model',
  'composer.selectModel': 'Select model',
  'composer.unavailable': 'Unavailable',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': 'Top up your balance to {amount} to keep chatting',
  'composer.generate': 'Generate',
  'composer.webSearch': 'Web access',
  'composer.webSearchOn': 'Web access on',
  'composer.autoMode': 'Auto mode',
  'composer.autoModeUsing': 'Uses {model}',
  'composer.manageModels': 'Manage models',
  'composer.searchModels': 'Search models…',
  'composer.providerAll': 'All providers',
  'composer.providerClaude': 'Claude',
  'composer.providerGrok': 'Grok',
  'composer.providerGemini': 'Gemini',
  'composer.providerGPT': 'GPT',
  'composer.providerKimi': 'Kimi',
  'composer.providerDeepSeek': 'DeepSeek',
  'composer.providerMicrosoft': 'Microsoft AI',
  'composer.internetOnly': 'Internet access only',
  'composer.internetAll': 'Any',
  'composer.internetWith': 'With internet',
  'composer.internetWithout': 'No internet',
  'composer.quickList': 'Quick list',
  'composer.addToQuickList': 'Add to quick list',
  'composer.removeFromQuickList': 'Remove from quick list',
  'composer.modelInfo': 'Model details',
  'composer.modelInfoOpen': 'Model details: {model}',
  'composer.modelInfoProvider': 'Provider',
  'composer.modelInfoSection': 'Section',
  'composer.modelInfoModality': 'Modality',
  'composer.modelInfoContextLimit': 'Context limit',
  'composer.modelInfoMaxOutput': 'Max output tokens',
  'composer.modelInfoPricingUnit': 'Pricing unit',
  'composer.modelInfoWebSearch': 'Web access',
  'composer.modelInfoStreaming': 'Streaming',
  'composer.modelInfoVision': 'Vision',
  'composer.modelInfoYes': 'Yes',
  'composer.modelInfoNo': 'No',
  'composer.noModelsForFilters': 'No models match current filters',
  'composer.resetFilters': 'Reset filters',
  'composer.difficultyAll': 'Any task',
  'composer.difficulty.fast': 'Fast answers',
  'composer.difficulty.normal': 'Normal tasks',
  'composer.difficulty.complex': 'Complex tasks',
  'composer.difficulty.expert': 'Expert tasks',
  'composer.modelsCount': '{count} models',
  'composer.clearSearch': 'Clear search',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': 'Character',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'AI Influencer',
  'character.soulIdTitle': 'Train a Soul ID',
  'character.characterTitle': 'Characters',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'AI Influencers',
  'character.name': 'Name',
  'character.description': 'Description',
  'character.bio': 'Bio',
  'character.style': 'Style',
  'character.scene': 'Scene',
  'character.prompt': 'Prompt',
  'character.referenceImages': 'Reference image URLs, one per line',
  'character.pickSoulId': 'Select a Soul ID',
  'character.pickCharacter': 'Select a character',
  'character.noSoulLinked': 'No linked Soul ID',
  'character.scopeLabel': 'What to create',
  'character.scopeHead': 'Head',
  'character.scopeFullBody': 'Full body',
  'character.scopeHeadHint': 'Close-ups of the face from different angles work best.',
  'character.scopeFullBodyHint': 'Add full-length photos so the whole body can be built.',
  'character.scopeBadgeHead': 'Head',
  'character.scopeBadgeFullBody': 'Full body',
  'character.model3dCreate': 'Create 3D model',
  'character.model3dView': 'View in 3D',
  'character.model3dBuilding': 'Building the 3D model… this takes a few minutes.',
  'character.model3dFailed': 'Could not build the 3D model',
  'character.model3dRetry': 'Try again',
  'character.model3dStarted': '3D model is being built',
  'character.model3dStage': '3D model viewer',
  'character.model3dLoading': 'Loading the model…',
  'character.model3dError': 'Could not open the 3D model.',
  'character.model3dUnsupported': 'Your device does not support 3D (WebGL).',
  'character.model3dHint': 'Drag to rotate · pinch or scroll to zoom',
  'character.model3dReset': 'Reset view',
  'character.model3dAutoRotate': 'Auto-rotate',
  'character.soulIdPhotoHint': 'Upload 5–20 reference photos.',
  'character.soulIdPhotoCount': 'Please choose between 5 and 20 photos.',
  'character.soulIdUploadFailed': 'Could not upload photos. Please try again.',
  'character.createSoulId': 'Create Soul ID',
  'character.createCharacter': 'Create character',
  'character.createAiInfluencer': 'Create AI influencer',
  'character.generateSoulCast': 'Generate Soul Cast',
  'character.generateContent': 'Generate content',
  'character.status.training': 'Training',
  'character.status.ready': 'Ready',
  'character.status.failed': 'Failed',
  'character.soulIdPhotoTips':
    'Best results: 10–20 sharp photos of one person — face from the front, both three-quarter views and profile, with and without a smile, different lighting, no sunglasses or other people.',
  'character.voiceSample': 'Voice sample (optional)',
  'character.voiceSampleHint':
    'Upload 30–120 s of clean speech (mp3, wav, m4a) to clone the voice; talking videos will then sound like this person.',
  'character.voiceSamplePick': 'Choose a recording',
  'character.identityPack': 'Identity pack',
  'character.identityPackHint':
    'Clean reference frames rendered from the photos; every generation uses them to keep the face stable.',
  'character.identityPackMissing': 'No identity pack: generations use the photos directly.',
  'character.likeness': 'Likeness {score}/100',
  'character.voiceReady': 'Voice cloned',
  'character.voiceFailed': 'Voice not cloned',
  'character.castMode': 'What to create',
  'character.castModeImage': 'Image in a scene',
  'character.castModeVideo': 'Video in a scene',
  'character.castModeTalking': 'Talking character (lip sync)',
  'character.castModePerformance': 'Transfer my acting (expressions + motion)',
  'character.castTier': 'Quality',
  'character.castTierBudget': 'Best value',
  'character.castTierMax': 'Maximum realism',
  'character.castTierTalkingHint': 'Best value: Kling AI Avatar v2 (~$0.06/s). Maximum: OmniHuman 1.5 (~$0.16/s) — emotions, gestures, body language.',
  'character.castTierPerformanceHint': 'Best value: Wan Animate (~$0.08/s). Maximum: Kling 3.0 Motion Control (~$0.17/s) — most faithful facial performance.',
  'character.castText': 'What the character says',
  'character.castTextHint': 'Spoken with the cloned voice when the Soul ID has one, otherwise with a studio voice. Up to 60 s.',
  'character.castAudio': 'or upload a recording (mp3, wav, m4a)',
  'character.castDrivingVideo': 'Video of you acting (mp4/mov, up to 30 s, 8 MB)',
  'character.castDrivingVideoHint': 'Film yourself from the front in good light: your facial expressions, head and body motion are transferred onto the character.',
  'character.castActingPrompt': 'Acting notes (optional)',
  'character.castNeedsSoul': 'Talking and acting videos need a trained Soul ID.',
  'character.castNeedsText': 'Enter the text or upload a recording.',
  'character.castNeedsVideo': 'Upload the video to transfer.',
  'character.castStarted': 'Generation started',
  'character.castTooLong': 'The file is longer than {max} s',
  'character.pickFile': 'Choose file',
  'character.removeFile': 'Remove',
  'character.quality': 'Quality',
  'character.qualityStandard': 'Standard (identity pack)',
  'character.qualityMax': 'Maximum (+ LoRA fine-tune, ~$3, 5–10 min)',
  'character.qualityHint':
    'Standard renders clean reference frames of you. Maximum additionally trains a personal model on your photos: the most faithful face in images.',
  'character.consentSelfie': 'Live selfie (consent)',
  'character.consentSelfieHint':
    'Take a selfie now with the camera. We check that the person in the photos is you; Soul IDs of other people are not allowed.',
  'character.consentSelfieTake': 'Take a selfie',
  'character.consentVerified': 'Identity confirmed',
  'character.consentFailed': 'Selfie did not match',
  'character.loraTraining': 'Training personal model…',
  'character.loraReady': 'Personal model ready',
  'character.loraFailed': 'Personal model failed',
  'character.checkPhotos': 'Check my photos',
  'character.checkingPhotos': 'Checking…',
  'character.photoCheckOk': 'The set looks good.',
  'character.photoCheckMissing': 'Missing: {items}',
  'character.photoCheckProblems': 'Problems: {items}',
  'character.recordVoice': 'Record a voice sample',
  'character.recordVoiceStop': 'Stop recording',
  'character.recordVoiceScript':
    'Read this aloud at a natural pace (60–90 s), close to the microphone, in a quiet room:',
  'character.recordVoiceScriptText':
    'Hi! Today I want to tell you about something that matters to me. Every morning begins the same way: coffee, a short walk and a plan for the day. Sometimes things go wrong, and that is fine, as long as you keep moving. Let me ask you a question: what would you do with one extra hour a day? Write it down, think about it, and do it tomorrow. Thank you for listening, see you soon!',
  'character.recordVoiceFailed': 'Could not access the microphone',
  'character.templates': 'Templates',
  'character.templateReel': 'Vertical reel',
  'character.templateFollowers': 'Message to followers',
  'character.templateProduct': 'Product review',
  'character.templateGreeting': 'Congratulations',
  'character.templateReelPrompt':
    'Vertical 9:16 lifestyle clip, handheld phone camera, golden hour city street, walking toward the camera and smiling',
  'character.templateFollowersText':
    'Hi everyone! Thanks for being here. I have big news to share this week, so stay tuned and do not miss the next post!',
  'character.templateProductText':
    'Today I am testing something new. First impressions: it is light, it works out of the box and it saved me time. Here is how I use it every day.',
  'character.templateGreetingText':
    'Happy birthday! I wish you health, joy and bright days. Let this year bring exactly what you have been dreaming about!',
  'character.enhancePrompt': 'Improve the prompt automatically (cinematic rewrite)',
  'character.upscale': 'Upscale the clip to 1080p afterwards',
  'character.estimate': 'Estimated cost: ≈ {rub} ₽',
  'character.estimateParts': 'in {parts} parts',
  'character.estimating': 'Calculating the cost…',
  'character.castDuration': 'Clip length',
  'character.part': 'Part {index} of {count}',
  'character.castModeUpscale': 'Upscaled 1080p version',
  'character.rateUp': 'Looks like me',
  'character.rateDown': 'Not like me',

  'message.attachContext': 'Attach message as context',
  'message.pinChapter': 'Pin as chapter',
  'message.unpinChapter': 'Unpin chapter',
  'chapters.title': 'Chapters',
  'message.rewind': 'Return here',
  'message.rewindTitle': 'Return to this message?',
  'message.rewindConfirm': 'This message and everything after it will be permanently deleted.',
  'message.retry': 'Retry',
  'message.notSent': 'Not sent. It will be retried when the connection is back.',
  'suggest.explain': 'Explain: ',
  'suggest.write': 'Write: ',
  'suggest.translate': 'Translate: ',
  'suggest.summarize': 'Summarize: ',
  'suggest.ideas': 'Come up with ideas for: ',
  'chat.scrollDown': 'Scroll to latest',
  'chat.offline': 'No connection. History is available offline.',
  'admin.subscriptionPlans': 'Subscription plans',
  'admin.placeholder.markup': 'e.g. 30',
  'admin.placeholder.usd': 'e.g. 90',
  'admin.placeholder.min': 'e.g. 5',
  'settings.showTransactions': 'Show',
  'shareSheet.title': 'Share answer',
  'shareSheet.hint': 'Anyone with the link will be able to view this conversation.',
  'shareSheet.messages': 'Messages',
  'shareSheet.more': 'More',
  'shareSheet.toChats': 'Send to a Volt chat or select messages…',
  'chat.pullNewChat': 'New chat',
  'message.copy': 'Copy',
  'message.copied': 'Copied',
  'message.share': 'Share',
  'message.regenerate': 'Regenerate',
  'message.edit': 'Edit',
  'message.save': 'Save & resend',
  'message.editError': 'Could not save changes. Your original message is unchanged; try again.',
  'message.up': 'Good response',
  'message.down': 'Bad response',
  'message.usage': '{model} · {input} in · {output} out · {cost}',
  'message.usageNoModel': '{input} in · {output} out · {cost}',
  'message.failed': 'Generation failed',
  'message.reasoningTitle': 'Processing steps',
  'conversation.pinnedBadge': 'Pinned',

  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.conversation': 'Share conversation',
  'share.selectMessages': 'Select multiple messages',
  'share.selectedCount': 'Selected: {count}',
  'share.forwardSelected': 'Forward selected messages',
  'share.exitSelection': 'Cancel selection',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': 'Send to chat',
  'share.noDestinations': 'No chats or groups available',
  'share.sentSuccess': 'Sent!',
  'share.mediaTitle': 'Share photo or video',
  'job.share': 'Share',
  'share.sending': 'Sending…',
  'share.loadingDestinations': 'Loading chats…',
  'artifact.preview': 'Preview',
  'artifact.code': 'Code',
  'artifact.open': 'Open artifact',
  'artifact.export': 'Export',
  'artifact.download': 'Download',
  'artifact.copy': 'Copy',
  'artifact.edit': 'Edit',
  'artifact.close': 'Close',
  'artifact.fullscreen': 'Fullscreen',

  'job.status': 'Status',
  'job.pending': 'Queued',
  'job.processing': 'Processing…',
  'job.done': 'Done',
  'job.failed': 'Failed',
  'job.cancelled': 'Cancelled',
  'job.result': 'Result',
  'video2.prompt': 'Marketing prompt',
  'video2.productSource': 'Product source',
  'video2.productFromUrl': 'Click-to-Ad (URL)',
  'video2.productFromImages': 'Create product from images',
  'video2.productExisting': 'Use existing product IDs',
  'video2.productUrl': 'Product URL',
  'video2.productIds': 'Product IDs (comma/newline separated)',
  'video2.productTitle': 'Product title',
  'video2.avatarType': 'Avatar',
  'video2.avatarNone': 'No avatar',
  'video2.avatarPreset': 'Preset avatar',
  'video2.avatarCustom': 'Custom avatar IDs',
  'video2.customAvatarIds': 'Custom avatar IDs (comma/newline separated)',
  'video2.adApproach': 'Ad approach',
  'video2.adApproachReference': 'Reference-driven (ad reference)',
  'video2.adApproachBlocks': 'Hook/Setting blocks',
  'video2.adReferenceId': 'Ad reference ID',
  'video2.hookId': 'Hook ID',
  'video2.settingId': 'Setting ID',
  'video2.mode': 'Mode',
  'video2.adFormat': 'Ad format',
  'video2.formatId': 'Format ID',
  'video2.duration': 'Duration (sec)',
  'video2.resolution': 'Resolution',
  'video2.aspectRatio': 'Aspect ratio',
  'video2.generateAudio': 'Generate audio',
  'video2.errorProductRequired':
    'Provide a product URL, existing product ID, or product images with title.',
  'video2.errorAdApproachRequired':
    'Provide an ad reference ID, or choose at least one of Hook/Setting.',
  'video2.errorFormatRequired': 'Format ID is required for dtc-ads.',

  'job.empty': 'No generations yet',
  'job.actions': 'Actions',
  'job.favoriteAdd': 'Add to favorites',
  'job.favoriteRemove': 'Remove from favorites',
  'job.favorited': 'Favorite',
  'job.regenerate': 'Regenerate',
  'job.viewPrompt': 'View prompt',
  'job.promptTitle': 'Prompt',
  'job.download': 'Download',
  'job.deleteTitle': 'Delete generation?',
  'job.deleteConfirm': 'This generation will be permanently deleted.',

  'video.modeLabel': 'Video mode',
  'video.modeCreate': 'Create',
  'video.modeEdit': 'Edit',
  'video.modeExtend': 'Extend',
  'video.modeMotionControl': 'Motion Control',
  'video.fieldGeneric': 'This field',
  'video.fieldImages': 'Images',
  'video.fieldReferenceImages': 'Reference images',
  'video.fieldFirstFrameImage': 'First frame image',
  'video.fieldLastFrameImage': 'Last frame image',
  'video.fieldMainVideo': 'Main video',
  'video.fieldClips': 'Clips / videos',
  'video.fieldAudio': 'Audio',
  'video.fieldInputVideo': 'Source video',
  'video.fieldLibraryVideo': 'App Library video',
  'video.fieldMotionVideo': 'Motion-reference video',
  'video.fieldCharacterImages': 'Character image(s)',
  'video.ratio': 'Ratio',
  'video.ratioAutoHelper': 'Auto adapts the ratio to the input content.',
  'video.duration': 'Duration',
  'video.durationInput': 'Matches the uploaded input video',
  'video.durationInputValue': 'Matches the uploaded input video: {value}',
  'video.resolution': 'Resolution',
  'video.audioGeneration': 'Audio generation',
  'video.audioLanguages': 'Supported languages: {languages}',
  'video.audioLanguagesMulti': 'multiple languages',
  'video.audioLanguagesUnavailable': 'Supported languages are not specified by this model.',
  'video.audioSourceMode': 'Source audio',
  'video.audioSourcePreserve': 'Keep source audio',
  'video.audioSourceChange': 'Change source audio',
  'video.orientation': 'Orientation',
  'video.orientationAuto': 'Auto',
  'video.orientationVideo': 'Video orientation',
  'video.orientationImage': 'Image orientation',
  'video.contentMode': 'Content mode',
  'video.contentModeGrokFirstFrame': 'First frame image',
  'video.contentModeGrokImages': 'Up to 7 images',
  'video.contentModeVeoImages': 'Up to 3 images',
  'video.contentModeVeoFrames': 'First / last frame images',
  'video.contentModeMinimaxMultimodal': 'Multimodal references',
  'video.contentModeMinimaxFrames': 'First / last frame images',
  'video.contentModeSeedanceMultimodal': 'Multimodal references',
  'video.contentModeSeedanceFrames': 'First / last frame images',
  'video.contentModeGeminiReferences': 'References',
  'video.contentModeGeminiFrames': 'First / last frame images',
  'video.contentModeWanMultimodal': 'Multimodal references',
  'video.contentModeWanFrames': 'First / last frame images',
  'video.contentModeWanReference': 'Reference to video',
  'video.contentModeWanImageEdit': 'Image editing',
  'video.contentModeWanVideoEdit': 'Video editing / reference video',
  'video.contentModeWanAudioInput': 'Audio input',
  'video.contentModeWanFirstFrame': 'First frame image',
  'video.promptLimit': 'Prompt limit: {max} characters',
  'video.modeModelListEmpty': 'No available models in this mode right now.',
  // prettier-ignore
  'video.modeModelListMissing': 'This mode is temporarily unavailable. Missing expected models: {ids}',
  'video.libraryVideoPlaceholder': 'Select a VEO video from App Library',
  'video.libraryVideoLoading': 'Checking App Library video metadata…',
  // prettier-ignore
  'video.libraryVideoHelper': 'Only completed VEO videos up to 140 seconds from App Library can be extended.',
  'video.libraryVideoEmpty': 'No eligible VEO videos were found in App Library yet.',
  'video.libraryVideoName': 'Selected asset',
  'video.libraryVideoDuration': 'Duration',
  'video.libraryVideoOrigin': 'Origin',
  'video.libraryVideoOriginUnknown': 'Unknown origin',
  'video.libraryVideoPreviewLabel': 'Preview of {name}',
  'video.clearFiles': 'Clear files',
  'video.howToUse': 'How to use',
  'video.helperRequired': 'Required.',
  'video.helperOptional': 'Optional.',
  'video.helperExactFiles': '{count} file(s).',
  'video.helperFileRange': '{min}-{max} file(s).',
  'video.helperMinFiles': 'Min {min} file(s).',
  'video.helperFormats': 'Formats: {formats}.',
  'video.helperMaxEach': 'Max {max} each.',
  'video.helperDuration': 'Duration: {min}-{max} s.',
  'video.helperTotalDuration': 'Total duration ≤ {max} s.',
  'video.helperMaxResolution': 'Up to {value}.',
  'video.validationRequired': '{field} is required',
  'video.validationPromptMax': 'Prompt exceeds the {max} character limit for this model',
  'video.validationCount': '{field}: too many files, maximum is {max}',
  'video.validationFormat': '{field}: "{name}" with format {mime} is not supported',
  'video.validationSize': '{field}: "{name}" exceeds the {max} limit',
  'video.validationDuration': '{field}: "{name}" must be between {min} and {max} seconds',
  'video.validationTotalDuration': '{field}: total duration must not exceed {max} seconds',
  'video.validationTotalCount': 'Total uploaded files must not exceed {max}',
  'video.validationUnsupported': '{field} is not supported for this model',
  'video.validationLibraryVideoReference':
    'The selected App Library video is missing a stable asset or job reference.',
  'video.validationLibraryVideoOriginMissing':
    'The selected App Library video is missing origin model metadata.',
  'video.validationLibraryVideoOriginInvalid':
    'Only videos originally generated by supported Google VEO models can be extended.',
  'video.validationLibraryVideoDurationMissing':
    'The selected App Library video is missing duration metadata.',
  'video.validationLibraryVideoMaxDuration':
    'The selected App Library video must be {max} seconds or shorter.',

  'image.modelInfo': 'Model info',
  'image.maxInputImages': 'Max input images',
  'image.inputFormats': 'Input formats',
  'image.imageSizeMax': 'Image size max',
  'image.modalities': 'Modalities',
  'image.nativeOutput': 'Native output',
  'image.flexibleRatio': 'Flexible ratio',
  'image.outputCount': 'Output images',
  'image.decreaseCount': 'Decrease count',
  'image.increaseCount': 'Increase count',
  'image.outputFormat': 'Output format',
  'image.background': 'Background',
  'image.backgroundOpaque': 'Opaque',
  'image.backgroundTransparent': 'Transparent',
  'image.quality': 'Quality',
  'image.attachImages': 'Attach images',
  'image.attachedImages': '{count} image(s) attached',
  'image.textOnly': 'Text-only model',
  'image.validationCount': 'Too many files: maximum is {max} for this model',
  'image.validationFormat': '"{name}": format {mime} is not supported by this model',
  'image.validationSize': '"{name}": file exceeds the {max} limit for this model',

  'design.subtitle': 'Open a design tool in a new window',
  'design.open': 'Open',

  'settings.title': 'Settings',
  'settings.profile': 'Profile',
  'settings.appearance': 'Appearance',
  'settings.theme': 'Theme',
  'settings.themeLight': 'Light',
  'settings.themeDark': 'Dark',
  'settings.themeSystem': 'System',
  'settings.language': 'Language',
  'settings.balance': 'Balance',
  'settings.topup': 'Top up',
  'settings.topupAmount': 'Amount, ₽',
  'settings.topupSubmit': 'Top up balance',
  'settings.transactions': 'Transaction history',
  'settings.noTransactions': 'No transactions yet',
  'settings.loadMore': 'Load more',
  'settings.notifications': 'Notifications',
  'settings.notificationsHint': 'Get notified when async generations finish',
  'settings.data': 'Your data',
  'settings.exportData': 'Export my data',
  'settings.deleteAccount': 'Delete account',
  'settings.deleteAccountTitle': 'Delete your account?',
  'settings.deleteAccountConfirm':
    'This permanently deletes your account, conversations and balance. This cannot be undone.',
  'settings.username': 'Username',
  'settings.name': 'Name',
  'settings.personalization': 'Personalization',
  'settings.customInstructions': 'Custom instructions',
  'settings.customInstructionsHint': 'Added to every chat system prompt',
  'settings.responseStyle': 'Response style',
  'settings.responseStyleDefault': 'Default',
  'settings.responseStyleFormal': 'Formal',
  'settings.responseStyleTeacher': 'Teacher',
  'settings.responseStyleConcise': 'Concise',
  'settings.rules': 'Rules',
  'settings.rulesHint': 'Add rules the assistant should follow',
  'settings.addRule': 'Add rule',
  'settings.ruleInputPlaceholder': 'New rule…',
  'settings.personalizationSaved': 'Personalization saved',

  'admin.title': 'Admin',
  'admin.stats': 'Statistics',
  'admin.users': 'Users',
  'admin.settings': 'Platform settings',
  'admin.markup': 'Markup, %',
  'admin.usdRub': 'USD → RUB rate',
  'admin.minBalance': 'Min balance, ₽',
  'admin.contextLimit': 'Context messages',
  'admin.models': 'Model pricing',
  'admin.price': 'Price',
  'admin.revenue': 'Revenue',
  'admin.cost': 'Provider cost',
  'admin.margin': 'Margin',
  'admin.activeUsers': 'Active (24h)',
  'admin.failedJobs': 'Failed jobs',
  'admin.ban': 'Ban',
  'admin.unban': 'Unban',
  'admin.adjustBalance': 'Adjust balance',
  'admin.reason': 'Reason',
  'admin.amount': 'Amount, ₽',
  'admin.debugConsole': 'Debug Console',
  'admin.errorHistory': 'Error History',
  'admin.tabModels': 'AI Models',
  'admin.tabOperations': 'Operations',
  'admin.tabAnalytics': 'Analytics',
  'admin.tabErrors': 'Errors',
  'admin.modelMonitoring': 'AI model monitoring',
  'admin.modelEventsSectionTitle': 'Event log',
  'admin.modelStatesSectionTitle': 'Model status',
  'admin.modelEventsEmpty': 'No model events found.',
  'admin.modelCheck': 'Check',
  'admin.modelDisable': 'Disable',
  'admin.modelActivate': 'Activate',
  'admin.modelMonitoringLoadFailed': 'Failed to load model monitoring.',
  'admin.syncNow': 'Sync now',
  'admin.analyticsLoadFailed': 'Failed to load analytics.',
  'admin.errorHistoryLoadFailed': 'Failed to load error history.',
  'admin.errorsEmpty': 'No errors recorded yet.',

  'error.UNAUTHORIZED': 'Your session expired. Please reopen the app.',
  'error.FORBIDDEN': 'You do not have access to this.',
  'error.USER_BANNED': 'Your account has been suspended.',
  'error.NOT_FOUND': 'Not found.',
  'error.RATE_LIMITED': 'Too many requests. Please slow down.',
  'error.DAILY_LIMIT_EXCEEDED': 'Daily limit reached. Try again tomorrow.',
  'error.INSUFFICIENT_BALANCE': 'Not enough balance for this request.',
  'error.BELOW_MIN_BALANCE': 'Your balance is below the minimum required.',
  'error.MODEL_UNAVAILABLE': 'This model is currently unavailable.',
  'error.MODEL_NOT_SUPPORTED': 'This model is not supported here.',
  'error.PROVIDER_ERROR': 'The provider returned an error.',
  'error.PROVIDER_TIMEOUT': 'The provider timed out.',
  'admin.blockedTopics': 'Blocked topics',
  'admin.blockedTopicsHint': 'Messages containing these words or phrases are refused for all users. A stem works for all forms: "casino" also blocks "casinos".',
  'admin.blockedTopicsPlaceholder': 'Word or phrase',
  'admin.blockedTopicsAdd': 'Add',
  'error.TOPIC_BLOCKED': 'This topic is blocked by the administrator.',
  'error.CONTEXT_TOO_LARGE': 'This conversation is too long for the model.',
  'error.PAYMENT_INVALID': 'The payment could not be processed.',
  'error.INTERNAL': 'Server error. Please try again.',
  'error.network': 'Network error. Check your connection.',
  'error.streamInterrupted': 'Connection interrupted. The response was recovered from the server.',
  'error.generic': 'Something went wrong.',
} as const;

export type TranslationKey = keyof typeof en;
